import * as xssFilters from 'xss-filters';
import { WebsiteInformation } from '../../models';

export function getCompanyStructuredData(website: WebsiteInformation) {
  return xssFilters.inHTMLData(JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": website.name,
    "url": website.siteUrl,
    "logo": website.siteLogoUrlSquare
  }));
}
